import { Maybe } from "generated/graphql";

export const responseBodyIsHtml = (body: string) => {
  const openTagPattern = /<html\s*?>/g;
  const closeTagPattern = /<\/html\s*?>/g;
  const openTagIndices = new Array<number>();
  const closeTagIndices = new Array<number>();
  let array;
  while ((array = openTagPattern.exec(body)) !== null) {
    if (array) openTagIndices.push(openTagPattern.lastIndex);
  }
  while ((array = closeTagPattern.exec(body)) !== null) {
    if (array) closeTagIndices.push(closeTagPattern.lastIndex);
  }
  if (
    // check if body is html
    openTagIndices.length === 1 &&
    closeTagIndices.length === 1 &&
    openTagIndices[0] < closeTagIndices[0]
  ) {
    return true;
  }
  return false;
};

export const getHeaderOfHtml = (body: string) => {
  const matches = body.match(/<h1\s*?>\s*?.*?\s*?<\/h1\s*?>/); // looking for h1 header tags
  const header = matches ? matches[0] : undefined;
  const start = header ? header.indexOf(">") + 1 : undefined;
  const end = header?.lastIndexOf("<");
  return header ? header.slice(start, end).trim() : undefined;
};

export const getNotificationToDisplay = (
  message: Maybe<string> | undefined,
  body: string | undefined
) => {
  let notificationToDisplay: string = "";

  if (message) {
    notificationToDisplay = notificationToDisplay.concat(
      `Status: ${message}\n`
    );
  }
  if (body) {
    let formattedBody: string | undefined = body.trim();
    if (responseBodyIsHtml(formattedBody)) {
      formattedBody = getHeaderOfHtml(formattedBody);
    }
    notificationToDisplay = formattedBody
      ? notificationToDisplay.concat(`ServiceNow Response: ${formattedBody}`)
      : notificationToDisplay;
  }
  return notificationToDisplay;
};
